import { sanitizeAndParseData } from '../../core/utils/sanitize-and-parse-data.js';
import type { XYChartSeriesWithDatapoints } from '../types/xy-chart-internals.js';

export function formatCSV(data: XYChartSeriesWithDatapoints[]) {
  const csvColumns = ['series', 'x0', 'x1', 'y0', 'y1', 'value'];

  let csv = `${csvColumns.join(',')}\n`;

  let index = 0;

  for (const series of data) {
    index++;
    const seriesRow = [`${series.type}-${index}`];

    for (const datapoint of series.data) {
      const parsedX0 = sanitizeAndParseData(datapoint.x0);
      const parsedX1 = sanitizeAndParseData(datapoint.x1);
      const parsedY0 = sanitizeAndParseData(datapoint.y0);
      const parsedY1 = sanitizeAndParseData(datapoint.y1);
      const parsedValue = sanitizeAndParseData(datapoint.value);
      const datapointsRow = [
        parsedX0,
        parsedX1,
        parsedY0,
        parsedY1,
        parsedValue,
      ];

      csv += `${seriesRow.concat(datapointsRow.toString()).join(',')}\n`;
    }
  }

  return csv;
}
